module.exports = __webpack_public_path__ + "img/core-event-logo-big.7693701d.png";